/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filescategorizing1Inputs */

const en_filescategorizing1 = /** @type {(inputs: Filescategorizing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categorizing…`)
};

const pt_filescategorizing1 = /** @type {(inputs: Filescategorizing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categorizar…`)
};

/**
* | output |
* | --- |
* | "Categorizing…" |
*
* @param {Filescategorizing1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filescategorizing1 = /** @type {((inputs?: Filescategorizing1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filescategorizing1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filescategorizing1(inputs)
	return pt_filescategorizing1(inputs)
});
export { filescategorizing1 as "filesCategorizing" }